import { Link } from "react-router-dom";
import type { Comic } from "@/mocks/comics";

interface Props {
  comic: Comic;
  rank?: number;
}

export default function ComicCard({ comic, rank }: Props) {
  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group relative flex flex-col overflow-hidden rounded-xl bg-background-100 ring-1 ring-background-200 transition-transform duration-300 hover:-translate-y-1 hover:ring-primary-300"
      aria-label={`查看《${comic.title}》详情`}
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden">
        <img
          src={comic.cover}
          alt={`${comic.title} 漫画封面`}
          title={`${comic.title} 漫画`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute left-2 top-2 flex items-center gap-1 rounded-full bg-primary-500/95 px-2.5 py-1 text-xs font-medium text-background-50">
          <i className="ri-star-fill" style={{ fontSize: "12px" }}></i>
          {comic.score}
        </div>
        {rank !== undefined && (
          <div
            className={`absolute right-2 top-2 flex h-8 w-8 items-center justify-center rounded-lg font-display text-lg text-background-50 ${
              rank < 3 ? "bg-accent-500" : "bg-foreground-900/80"
            }`}
          >
            {rank}
          </div>
        )}
        {comic.status === "已完结" && (
          <div className="absolute bottom-2 right-2 rounded-full bg-foreground-900/80 px-2 py-0.5 text-xs text-background-50">
            已完结
          </div>
        )}
      </div>

      <div className="flex flex-1 flex-col p-3">
        <div className="flex items-center justify-between gap-2">
          <span className="rounded-md bg-secondary-100 px-2 py-0.5 text-xs text-secondary-800">{comic.category}</span>
          <span className="text-xs text-foreground-400">{comic.views}</span>
        </div>
        <h3 className="mt-2 truncate font-medium text-foreground-950 group-hover:text-primary-700 transition-colors">
          {comic.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500">{comic.updates}</p>
      </div>
    </Link>
  );
}